/* src/app/shared/signature/signature.component.scss */
.signature-canvas-wrapper {
  position: relative;
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  border: 1px solid var(--ion-color-medium);
  padding: 2px;
  border-radius: 7px;
}
#signature-canvas {
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
  background-color: white;
  touch-action: none;
}
.tip {
  color: var(--ion-color-medium);
  font-size: 0.8em;
  margin-top: 0;
  font-style: italic;
}
/*# sourceMappingURL=signature.component.css.map */
